export default class DataTableService
{
	constructor(AppService) {
		this.AppService = AppService;

		this.baseData = null;
		this.compareData = null;
		this.combinedData = [];
		this.combinedTotalPax = {
			baseTotal: 0,
			compareTotal: 0
		};

		this.$element = null;

		this.settings = {
			destroy: true,
			order: []
		};
		this.overviewSettings = {
			destroy: true,
			order: []
		};
	}

	updateBaseData(data) {
		this.baseData = data;
		this.buildCombinedData();
	}

	updateCompareData(data) {
		this.compareData = data;

		this.combinedTotalPax.baseTotal = 0;
		this.baseData.map((v, i) => {
			this.combinedTotalPax.baseTotal += v[1];
		});

		this.combinedTotalPax.compareTotal = 0;
		this.compareData.map((v, i) => {
			this.combinedTotalPax.compareTotal += v[1];
		});

		this.buildCombinedData();
	}

	buildCombinedData() {
		// No base data
		if (!Array.isArray(this.baseData)) {
			return this.combinedData = [];
		}

		// If no compare data
		if (!Array.isArray(this.compareData)) {
			return this.combinedData = this.baseData;
		}

		// If shouldn't match
		if (!this.shouldMatch()) {
			return this.combinedData = this.baseData.map((v, i) => {
				if (Array.isArray(this.compareData[i])) {
					// console.log(Array.isArray(this.compareData[i]));
					return v.concat(this.compareData[i]);
				} else {
					// console.log('nope');
					return v.concat(['', 0]);
				}
			});
		}

		// Match
		let matchList = this.compareData.map((value, index) => { return value[0]; });

		return this.combinedData = this.baseData.map((v, i) => {
			let matchI = matchList.indexOf(v[0]);
			if (matchI > -1) {
				return v.concat(this.compareData[matchI]);
			} else {
				return v.concat([v[0], 0]);
			}
		});
	}

	// Match unless x axis is a date
	shouldMatch() {
		if (this.baseData.length > 0) {
			return Array.isArray(this.baseData) && Array.isArray(this.compareData) && isNaN(Date.parse(this.baseData[0][0]));
		} else {
			return Array.isArray(this.baseData) && Array.isArray(this.compareData);
		}
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/services/datatable.service.js
 **/